import { unreachable } from 'utils/unreachable';
export const UserPresenceChannel = (id)=>[
        'user_presence_channel',
        id
    ];
export const ProjectChannel = (a, b, c)=>[
        'project_channel',
        a,
        b,
        c
    ];
export const AccountChannel = (accountId, permissionId)=>[
        'account_channel',
        accountId,
        permissionId
    ];
export const RevenueEntryOverviewChannel = (accountId, permissionId)=>[
        'revenue_entry_overview_channel',
        accountId,
        permissionId
    ];
export const UserChannel = (accountId, userId)=>[
        'user_channel',
        userId,
        accountId
    ];
export const ProjectPresenceChannel = (accountId, projectId)=>[
        'project_presence_channel',
        accountId,
        projectId
    ];
export const InvoiceChannel = (a, b, c)=>[
        'invoice_channel',
        a,
        b,
        c
    ];
export const name = (channel)=>{
    switch(channel[0]){
        case 'user_presence_channel':
            return `presence-accountId@${channel[1][1]}`;
        case 'user_channel':
            return `private-accountId@${channel[2][1]}-userId@${channel[1][1]}`;
        case 'project_channel':
            return `private-accountId@${channel[1][1]}-permissionId@${channel[2][1]}-projectId@${channel[3][1]}`;
        case 'account_channel':
            return `private-accountId@${channel[1][1]}-permissionId@${channel[2][1]}`;
        case 'revenue_entry_overview_channel':
            return `private-accountId@${channel[1][1]}-permissionId@${channel[2][1]}-REVENUE_ENTRY_OVERVIEW_PRIVATE_CHANNEL`;
        case 'project_presence_channel':
            return `presence-accountId@${channel[1][1]}-projectId@${channel[2][1]}`;
        case 'invoice_channel':
            return `private-accountId@${channel[1][1]}-permissionId@${channel[2][1]}-invoiceId@${channel[3][1]}`;
        default:
            return unreachable(channel);
    }
};
